export interface Pago_sueldo {
  id: number;
  created_at: string;		
  cobra:string;	
  nombre_pago	:string;			
  importe	: number;
  paga:string;
  notas:string;
}

export const pago_sueldo_inicial: Pago_sueldo = {
  id: 1,
  created_at: '',		
  cobra: '',
  nombre_pago	: '',			
  importe	: 0,
  paga:'',
  notas:''
};
